/* @flow */
import * as React from 'react';

import Icon from 'components/Icon';

type IconMap = { [string]: React.Element<typeof Icon> };

export function getIconCellGenerator(fieldName: string, iconMap: IconMap) {
  return (data: Object) => {
    const icon = iconMap[data[fieldName]];
    return icon ? React.cloneElement(icon) : <span data-test="empty-icon-cell" />;
  };
}
